import { render, staticRenderFns } from "./LargeMediaSetting.vue?vue&type=template&id=6b3a9b9a"
import script from "./LargeMediaSetting.vue?vue&type=script&lang=js"
export * from "./LargeMediaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports